import { ErrorLink } from '@apollo/client/link/error';
import { ERROR_PREFIXES } from 'src/common/constants';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { createDatadogError } from 'src/services/datadog/utils/createDatadogError';
const UNAUTHORIZED_ERROR = 'UnauthorizedResponse';
export const UnauthorizedResponseError = createDatadogError(UNAUTHORIZED_ERROR);

export const GRAPHQL_SIGN_OUT_ERROR = 'User has been signed out due to unauthorized API response';

declare global {
    // eslint-disable-next-line no-var
    var loggedErrors: Record<string, boolean> | undefined;
}

export const logUnauthorizedResponseError: ErrorLink.ErrorHandler = ({
    graphQLErrors,
    networkError,
    operation,
    response,
}) => {
    if (!globalThis.loggedErrors) {
        globalThis.loggedErrors = {};
    }
    if (globalThis.loggedErrors[UNAUTHORIZED_ERROR]) {
        return;
    }
    globalThis.loggedErrors[UNAUTHORIZED_ERROR] = true;
    const error = new UnauthorizedResponseError(`${ERROR_PREFIXES.APPLICATION_SESSION} ${GRAPHQL_SIGN_OUT_ERROR}`);
    DatadogRUMService.Client.getInstance().addError(error, {
        graphQLErrorsAsString: JSON.stringify(graphQLErrors, null, 2),
        graphQLErrors,
        networkError,
        operation,
        response,
    });
};
